import { Link, useParams } from 'react-router-dom';

import { Button, Typography } from 'shared';

import { CoachingSessionRecapMessageContent } from 'features/chat/config/types/Message';
import { getSessionRecapTabQueryParam } from 'features/controlCenter/utils/task';
import { useOpenSessionRecapModal } from 'features/sessions/hooks/useOpenSessionRecapModal';
import { useSessionNavigationLink } from 'features/sessions/hooks/useSessionNavigationLink';
import { useIsCoachMode } from 'features/user/hooks/useIsCoachMode';

type CoachingSessionViewRecapProps = Omit<
  CoachingSessionRecapMessageContent,
  'type'
> & {
  bg: string;
};

export const CoachingSessionViewRecap = ({
  coachingSessionId,
  bg,
  ...rest
}: CoachingSessionViewRecapProps) => {
  const { email } = useParams();
  const sessionLink = useSessionNavigationLink({
    coachingSessionId,
    email: email!,
  });

  const openRecapModal = useOpenSessionRecapModal({
    ...rest,
    title: rest.subject,
  });

  const isCoachUser = useIsCoachMode();

  return isCoachUser ? (
    <Link to={`${sessionLink}${getSessionRecapTabQueryParam()}`}>
      <ViewRecapButton bg={bg} />
    </Link>
  ) : (
    <ViewRecapButton bg={bg} onClick={openRecapModal} />
  );
};

const ViewRecapButton = ({
  bg,
  onClick,
}: {
  bg: string;
  onClick?: () => void;
}) => (
  <Button
    bg={bg}
    w="full"
    onClick={onClick}
    _hover={{
      bg,
    }}
  >
    <Typography as="span" color="whiteTotal" fontWeight="medium">
      View recap
    </Typography>
  </Button>
);
